import { render, staticRenderFns } from "./EmpEdit.vue?vue&type=template&id=61ccef7c"
import script from "./EmpEdit.vue?vue&type=script&lang=js"
export * from "./EmpEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports